<template>
  <button
    v-on="$listeners"
    class="base-button"
    :class="{'base-button--full': full, 'base-button--danger': danger, 'base-button--success': success}"
  >
    {{ label }}<slot />
  </button>
</template>

<script>
export default {
    name: 'BaseButton',
    props: {
        label: {
            type: String,
            required: true,
        },
        full: { type: Boolean, default: false },
        danger: { type: Boolean, default: false },
        success: { type: Boolean, default: false },
    },
};
</script>

<style lang="scss" scoped>
.base-button {
    background: $brand;
    border: none;
    color: $white;
    cursor: pointer;
    display: block;
    // min-width: 200px;
    outline: none;
    padding: 10px 20px;
    transition: background .15s ease-in-out;
    height: 40px;
    border-radius: 5px;

    &:hover, &:focus {
        background: darken($brand, 5%);
    }

    &--full {
        width: 100%;
    }

    &--danger {
        background: #ff001e;
        &:hover {
            background: #ff001e;
        }
    }

    &--success {
        background: $green;
        &:hover {
            background: $green;
        }
    }

    &:disabled {
        background: $black2;
        cursor: not-allowed;
    }
}
</style>
